export const landing = () => {

	const handleToggle = (e) => {
		e.preventDefault();
		let modalEl = document.getElementById( e.currentTarget.getAttribute('href').slice(1) );
		modalEl.classList.toggle('is-open');
	};

    const speakerLinks = document.querySelectorAll('.landing-speakers-item--link');

    speakerLinks.forEach((speakerLink) => {
      speakerLink.addEventListener('click', handleToggle);
    });

	const modalCloseLinks = document.querySelectorAll('.landing-speakers-modal-close');

    modalCloseLinks.forEach((modalCloseLink) => {
      modalCloseLink.addEventListener('click', handleToggle);
    });

};
